import { Navigate } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { getIsAuthenticated, getIsProfileComplete, getRefreshToken } from "@/src/auth/store/auth-selectors";
import { buildCommunityUrl, getSubdomain } from "@/src/common/lib/subdomain";
import { useAppSelector } from "@/src/common/redux/store";
import PublicCommunityHomePage from "@/src/community/pages/public-community-home-page";
import { getCommunities } from "@/src/community/store/community-selectors";
import { ONBOARDING_ROUTES } from "@/src/onboarding/constants/onboarding-routes";
import { POST_ROUTES } from "@/src/post/constants/post-routes";

export function RootRedirect() {
	const isAuthenticated = useAppSelector(getIsAuthenticated);
	const isProfileComplete = useAppSelector(getIsProfileComplete);
	const refreshToken = useAppSelector(getRefreshToken);
	const communities = useAppSelector(getCommunities);
	const subdomain = getSubdomain();

	if (subdomain) {
		if (isAuthenticated) {
			return <Navigate to={POST_ROUTES.FEED} replace />;
		}
		const params = new URLSearchParams(window.location.search);
		const hasSigninAction = params.get("action") === "signin";
		if (hasSigninAction || refreshToken) {
			return <Navigate to={AUTH_ROUTES.AUTH} replace />;
		}
		return <PublicCommunityHomePage slug={subdomain} />;
	}

	if (!isAuthenticated) {
		return <Navigate to={AUTH_ROUTES.AUTH} replace />;
	}

	if (!isProfileComplete) {
		return <Navigate to={ONBOARDING_ROUTES.PROFILE} replace />;
	}

	if (communities.length === 0) {
		return <Navigate to={ONBOARDING_ROUTES.CREATE_COMMUNITY_PROFILE} replace />;
	}

	const singleCommunity = communities[0];
	if (communities.length === 1 && singleCommunity) {
		window.location.href = buildCommunityUrl(singleCommunity.slug, POST_ROUTES.FEED);
		return null;
	}

	return <Navigate to={ONBOARDING_ROUTES.SELECT_COMMUNITY} replace />;
}
